import { Box, Grid } from '@mui/material';
import { PaddleStatus, PaddleWebhookEvent, WebhookEventDistribution } from '../../../../types/admin';
import RefreshButton from '../../system/shared/RefreshButton';
import AdminMetricCard from '../../shared/AdminMetricCard';
import PaddleStatusCard from './PaddleStatusCard';
import WebhookEventsTable from './WebhookEventsTable';
import WebhookEventDistributionChart from './WebhookEventDistributionChart';
import { formatNumber } from '../../../../utils/formatters';

interface PaddleIntegrationTabProps {
  paddleStatus: PaddleStatus;
  recentEvents: PaddleWebhookEvent[];
  eventDistribution: WebhookEventDistribution[];
  loading?: boolean;
  lastUpdated: string;
  onRefresh: () => void;
}

export default function PaddleIntegrationTab({
  paddleStatus,
  recentEvents,
  eventDistribution,
  loading,
  lastUpdated,
  onRefresh,
}: PaddleIntegrationTabProps) {
  return (
    <Box>
      {/* Header with Refresh Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <RefreshButton onRefresh={onRefresh} lastUpdated={lastUpdated} loading={loading} />
      </Box>

      {/* Paddle Status */}
      <Box sx={{ mb: 4 }}>
        <PaddleStatusCard status={paddleStatus} loading={loading} />
      </Box>

      {/* Webhook Metrics */}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard
            title="Webhook Success Rate"
            value={`${paddleStatus.webhook_success_rate}%`}
            subtitle="Overall reliability"
            loading={loading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard
            title="Webhooks Today"
            value={formatNumber(paddleStatus.total_webhooks_today)}
            subtitle={`${paddleStatus.failed_webhooks_today} failed`}
            loading={loading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard
            title="Failed Today"
            value={formatNumber(paddleStatus.failed_webhooks_today)}
            subtitle="Requires attention"
            loading={loading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard
            title="API Status"
            value={paddleStatus.api_connected ? 'Connected' : 'Disconnected'}
            subtitle="Paddle API"
            loading={loading}
          />
        </Grid>
      </Grid>

      {/* Charts and Tables */}
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} lg={4}>
          <WebhookEventDistributionChart data={eventDistribution} loading={loading} />
        </Grid>
        <Grid item xs={12} lg={8}>
          <WebhookEventsTable events={recentEvents} loading={loading} />
        </Grid>
      </Grid>
    </Box>
  );
}
